






































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Auth, Storage } from 'aws-amplify';
import { Project } from '@/models/project';
import { User } from '@/models/user';
import AWS from 'aws-sdk';
import { State } from 'vuex-class';
import VueSlider from 'vue-slider-component';

type ScreenType = 'intro' | 'outro';
type Align = 'left' | 'center' | 'right';
type DOMCanvasTextAlign = 'left' | 'right' | 'center' | 'start' | 'end';
type BgMode = 'image' | 'color';
type FlatIOValue = {
  INTRO_URL?: string;
  INTRO_KEY?: string;
  INTRO_DURATION_MS?: number;
  OUTRO_URL?: string;
  OUTRO_KEY?: string;
  OUTRO_DURATION_MS?: number;
  INTRO_OUTRO_ENABLED?: boolean;
  [k: string]: any;
};

interface TextBlock {
  id: string;
  text: string;
  x: number;
  y: number;
  fontSize: number;
  fontFamily: string;
  color: string;
  align: Align;
  w: number;
  h?: number;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
}

interface LogoItem {
  id: string;
  src: string;
  x: number; // px canvas
  y: number; // px canvas
  scale: number; // 1 = taille naturelle
  natW?: number;
  natH?: number;
}

interface ScreenConfig {
  bgMode: BgMode; // NEW
  bgColor: string; // NEW (#RRGGBB)
  blur: number; // existant
  texts: TextBlock[];
  logos: LogoItem[];
}

export interface IntroOutroModel {
  intro: ScreenConfig;
  outro: ScreenConfig;
}

const ABS_URL = /^https?:\/\//i;

@Component({
  components: { VueSlider },
})
export default class TimelapseIntroOutro extends Vue {
  @Prop({ type: Object, required: true }) readonly camera!: any;
  @Prop({ type: String, required: true }) readonly firstImageUrl!: string;
  @Prop({ type: String, required: true }) readonly lastImageUrl!: string;
  @Prop({ type: Number, default: 4000 }) readonly width!: number;
  @Prop({ type: Number, default: 3000 }) readonly height!: number;
  @Prop({ type: String, default: '' }) readonly firstImageKey!: string; // clé S3 éventuellement (peut commencer par "public/")
  @Prop({ type: String, default: '' }) readonly lastImageKey!: string;
  @Prop({ type: Function, default: null })
  readonly urlResolver!: ((key: string) => Promise<string | null | undefined>) | null;

  @State('project', { namespace: 'projects' }) private project!: Project | null;
  @State('user', { namespace: 'profile' }) private user!: User;

  @Prop({ required: true }) readonly ownerId!: string;
  @Prop({ required: true }) readonly projectId!: string;
  @Prop({ required: true }) readonly cameraId!: string;
  @Prop({ type: Number, default: 2000 }) readonly introDurationMs!: number; // ms
  @Prop({ type: Number, default: 2000 }) readonly outroDurationMs!: number; // ms

  @Prop({ type: Object, required: true })
  readonly value!: FlatIOValue;

  introMs: number = this.introDurationMs;
  outroMs: number = this.outroDurationMs;

  @Watch('introDurationMs') onIntroMsProp(v: number) {
    this.introMs = v;
  }
  @Watch('outroDurationMs') onOutroMsProp(v: number) {
    this.outroMs = v;
  }

  private screenDurationMs(s: 'intro' | 'outro') {
    return s === 'intro' ? this.introDurationFromModel : this.outroDurationFromModel;
  }

  // état interne
  activeScreen: ScreenType = 'intro';
  local: IntroOutroModel = {
    intro: { bgMode: 'image', bgColor: '#0b1a2a', blur: 18, texts: [], logos: [] },
    outro: { bgMode: 'image', bgColor: '#0b1a2a', blur: 18, texts: [], logos: [] },
  };

  // snap configuration
  snap = { step: 10, threshold: 6 }; // grille 10px, seuil 6px
  guidesV: number[] = [];
  guidesH: number[] = [];

  introBgUrl = '';
  outroBgUrl = '';

  ioeVisible = false; // état ouvert/fermé de l'accordéon
  enabled = true; // switch Activer

  // Pour éviter de boucler sur @error
  introBgErrorOnce = false;
  outroBgErrorOnce = false;

  // redimensionnement en cours
  resizing: null | {
    id: string;
    corner: 'nw' | 'ne' | 'sw' | 'se';
    startMouseX: number;
    startMouseY: number;
    startX: number;
    startY: number;
    startW: number;
    startH: number;
    // ▼ Optionnels — utilisés uniquement pour les LOGOS
    startScale?: number;
    natW?: number;
    natH?: number;
  } = null;

  // sélection & drag
  selected: { type: 'text' | 'logo'; id: string } | null = null;
  dragging = false;
  dragOffset = { dx: 0, dy: 0 };

  introMsLive = 0;
  outroMsLive = 0;

  // pour calculer l’échelle DOM -> canvas
  stageRect: DOMRect | null = null;

  // fonts dispo
  fonts: string[] = ['Arial', 'Helvetica', 'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Georgia', 'Times New Roman'];
  editingId: string | null = null;
  editingBackup = '';
  // === COMPUTED-LIKE ===

  get introDurationFromModel(): number {
    if (this.value && typeof this.value.INTRO_DURATION_MS === 'number') {
      return this.value.INTRO_DURATION_MS;
    }
    return this.introDurationMs; // fallback prop par défaut (2000)
  }

  get outroDurationFromModel(): number {
    if (this.value && typeof this.value.OUTRO_DURATION_MS === 'number') {
      return this.value.OUTRO_DURATION_MS;
    }
    return this.outroDurationMs; // fallback prop par défaut (2000)
  }

  get isEditing(): boolean {
    return !!this.editingId;
  }

  get stageScale(): number {
    return this.stageRect ? this.stageRect.width / this.width : 1;
  }

  get current(): ScreenConfig {
    return this.local[this.activeScreen];
  }

  get activeBgUrl(): string {
    // On privilégie l’URL résolue signée, sinon on retombe sur la prop brute
    return this.activeScreen === 'intro'
      ? this.introBgUrl || this.firstImageUrl || ''
      : this.outroBgUrl || this.lastImageUrl || '';
  }

  get selectedType(): 'text' | 'logo' | null {
    return this.selected ? this.selected.type : null;
  }

  get stageStyle() {
    return { width: '100%', aspectRatio: `${this.width} / ${this.height}` };
  }

  get selectedEl(): any | null {
    if (!this.selected) return null;
    if (this.selected.type === 'text') {
      return this.current.texts.find((t) => t.id === this.selected!.id) || null;
    }
    return this.current.logos.find((l) => l.id === this.selected!.id) || null;
  }

  get selectionStyle() {
    if (!this.selectedEl || !this.stageRect) return {};
    const scale = this.stageRect.width / this.width;

    if (this.selected && this.selected.type === 'text') {
      const t = this.selectedEl as TextBlock;
      const w = Math.max(120, t.w);
      const hDom = t.h ? t.h * scale : this.getTextDomHeightPx(t); // ⬅️ priorité à t.h
      return {
        left: t.x * scale + 'px',
        top: t.y * scale + 'px',
        width: w * scale + 'px',
        height: hDom + 'px',
      };
    } else {
      // logo
      const l = this.selectedEl as any; // LogoItem
      const w = (l.natW || 200) * (l.scale || 1);
      const h = (l.natH || 100) * (l.scale || 1);
      return {
        left: l.x * scale + 'px',
        top: l.y * scale + 'px',
        width: w * scale + 'px',
        height: h * scale + 'px',
      };
    }
  }

  get logoScalePct(): number {
    const el = this.selectedEl as LogoItem | null;
    if (!el || this.selected?.type !== 'logo') return 100;
    return Math.round((el.scale || 1) * 100);
  }

  get introOutroEnabled(): boolean {
    // Par défaut : activé si on a déjà une intro ou une outro
    const v = this.value || {};
    if (typeof v.INTRO_OUTRO_ENABLED === 'boolean') {
      return v.INTRO_OUTRO_ENABLED;
    }
    return !!(v.INTRO_KEY || v.OUTRO_KEY);
  }

  set introOutroEnabled(val: boolean) {
    this.emitMerge({ INTRO_OUTRO_ENABLED: val });
  }

  private emitMerge(patch: Partial<FlatIOValue>) {
    const next: FlatIOValue = { ...(this.value || {}), ...patch };
    this.$emit('input', next);
    this.$emit('change', next);
  }

  private getTextRootEl(id: string): HTMLElement | null {
    const ref = this.$refs['text-' + id] as any;
    return Array.isArray(ref) ? (ref[0] as HTMLElement) : (ref as HTMLElement);
  }
  private getEditAreaEl(id: string): HTMLTextAreaElement | null {
    const ref = this.$refs['editArea-' + id] as any;
    return Array.isArray(ref) ? (ref[0] as HTMLTextAreaElement) : (ref as HTMLTextAreaElement);
  }

  onToggleEnabled() {
    // Optionnel : visuel "grisé" + blocage des interactions géré par :disabled et .ioe-disabled
    this.emitModel(); // on pousse l'état si tu veux le stocker côté parent plus tard
  }

  resetCurrent() {
    const def: ScreenConfig = { bgMode: 'image', bgColor: '#0b1a2a', blur: 18, texts: [], logos: [] };
    this.local[this.activeScreen] = JSON.parse(JSON.stringify(def));
    this.emitModel();
  }

  getLogoBox(l: any) {
    const natW = l.natW || 200;
    const natH = l.natH || 100;
    const sc = l.scale || 1;
    return { w: natW * sc, h: natH * sc };
  }

  getTextDomHeightPx(t: TextBlock): number {
    const ref = this.$refs['text-' + t.id] as any;
    const el: HTMLElement | null = Array.isArray(ref) ? (ref[0] as HTMLElement) : (ref as HTMLElement);
    return el
      ? el.offsetHeight
      : Math.max(1, Math.round(t.fontSize * 1.4 * Math.max(1, (t.text || '').split('\n').length)));
  }

  onGlobalMouseDown = (ev: MouseEvent) => {
    const stageEl = this.$refs.stage as HTMLElement | undefined;
    const target = ev.target as Node;

    // 1) si on édite un texte, fermer si clic en dehors du bloc texte (ou de sa toolbar)
    if (this.editingId) {
      const textEl = this.getTextRootEl(this.editingId);
      const clickedInsideText = !!(textEl && textEl.contains(target));
      if (!clickedInsideText) {
        this.finishInlineEdit(true);
        this.selected = null; // masque les pointillés + toolbar
      }
      return;
    }

    // 2) sinon, si on clique totalement en dehors du stage → déselection
    if (stageEl && !stageEl.contains(target)) {
      this.selected = null;
      return;
    }

    // 3) dans le stage mais pas sur un item → déselection
    const el = target as HTMLElement;
    const item = el.closest ? el.closest('.ioe-item') : null;
    if (!item) this.selected = null;
  };

  // === LIFECYCLE ===

  private normalizeScreenDefaults(cfg: any): ScreenConfig {
    return {
      bgMode: (cfg && cfg.bgMode) || 'image',
      bgColor: (cfg && cfg.bgColor) || '#0b1a2a',
      blur: cfg && typeof cfg.blur === 'number' ? cfg.blur : 18,
      texts: (cfg && cfg.texts) || [],
      logos: (cfg && cfg.logos) || [],
    };
  }

  private preventDrag = (e: DragEvent) => e.preventDefault();

  async mounted() {
    if (this.value) this.local = JSON.parse(JSON.stringify(this.value));
    // ★ normalisation
    this.local.intro = this.normalizeScreenDefaults(this.local.intro);
    this.local.outro = this.normalizeScreenDefaults(this.local.outro);

    this.$nextTick(() => {
      const el = this.$refs.stage as HTMLElement;
      this.stageRect = el.getBoundingClientRect();
      window.addEventListener('resize', this.onResize);
    });
    await this.refreshBg('intro');
    await this.refreshBg('outro');
    document.addEventListener('mousedown', this.onGlobalMouseDown);
    document.addEventListener('keydown', this.onKeyDown);
    this.introMsLive = this.introDurationFromModel;
    this.outroMsLive = this.outroDurationFromModel;
    const stage = this.$refs.stage as HTMLElement;
    stage?.addEventListener('dragstart', this.preventDrag); // ⬅️
  }

  private stripPublic(k: string | null | undefined): string {
    const s = String(k || '').replace(/^\/+/, '');
    return s.replace(/^(?:public\/)+/i, '');
  }

  private isAbsoluteUrl(s: string): boolean {
    return ABS_URL.test(String(s || ''));
  }

  /** N'ajoute PUBLIC que pour des clés (pas pour des URLs) */
  private ensurePublicPrefixKey(key: string): string {
    if (!key) return '';
    if (this.isAbsoluteUrl(key)) return key; // ne pas toucher une URL
    const s = key.replace(/^\/+/, '');
    return s.startsWith('public/') ? s : `public/${s}`;
  }

  /** Extrait la clé depuis une URL S3 presignée, et force le préfixe public/ si absent */
  private keyFromAbsoluteUrl(url: string): string | null {
    try {
      const u = new URL(url);
      let path = decodeURIComponent(u.pathname.replace(/^\/+/, '')); // ex: "public/a/b/c.jpg"
      if (!path.startsWith('public/')) path = 'public/' + path;
      return path;
    } catch {
      return null;
    }
  }

  /** Variante petit format = suffixe après l’extension → "image.jpg-small" */
  private toSmallAfterExtKey(key: string): string {
    const k = this.ensurePublicPrefixKey(key).split('?')[0];
    // évite les doublons
    if (/(\.[a-z0-9]+)-medium$/i.test(k)) return k;
    return k.replace(/(\.[a-z0-9]+)$/i, '$1-medium');
  }

  /** Signe une *clé* (jamais une URL) au niveau public/ sans re-doubler le préfixe */
  private async signPublicKey(key: string): Promise<string> {
    const k = this.ensurePublicPrefixKey(key);
    const url = await Storage.get(k, {
      level: 'public',
      expires: 900,
      cacheControl: 'max-age=60',
      customPrefix: { public: '' }, // évite /public/public/
    });
    return String(url);
  }

  onIntroOutroToggle(val: boolean) {
    if (val) {
      this.ioeVisible = true;
    }
  }

  /** Prend une *clé OU une URL*, renvoie l’URL signée en *.jpg-small */
  private async smallSignedUrl(input: string): Promise<string> {
    if (!input) return '';
    if (this.isAbsoluteUrl(input)) {
      const key = this.keyFromAbsoluteUrl(input);
      if (!key) return input; // dernier recours : on rend l’URL telle quelle
      return await this.signPublicKey(this.toSmallAfterExtKey(key));
    } else {
      return await this.signPublicKey(this.toSmallAfterExtKey(input));
    }
  }

  private toSmallPreExt(key: string): string {
    const k = this.ensurePublicPrefix(key).split('?')[0];
    const inner = k.slice('public/'.length);
    const m = inner.match(/(.+?)(\.[a-z0-9]+)$/i);
    const finalInner = m ? `${m[1]}-medium${m[2]}` : `${inner}-medium`;
    return `public/${finalInner}`;
  }

  private async getSignedUrlPublic(key: string): Promise<string> {
    const withPublic = this.ensurePublicPrefix(key);
    const url = await Storage.get(withPublic, {
      level: 'public',
      expires: 900,
      cacheControl: 'max-age=60',
      // Empêche Amplify de re-préfixer → évite /public/public/
      customPrefix: { public: '' },
    });
    // Sécurité : si jamais le chemin ne contient pas /public/, on le patche
    try {
      const u = new URL(String(url));
      if (!u.pathname.startsWith('/public/')) {
        u.pathname = '/public' + (u.pathname.startsWith('/') ? u.pathname : '/' + u.pathname);
        return u.toString();
      }
    } catch {
      /* no-op */
    }
    return String(url);
  }

  /** Résout une URL finale à partir d’une URL absolue OU d’une clé S3 */
  private async resolveKeyOrUrl(raw: string): Promise<string> {
    const s = String(raw || '').trim();
    if (!s) return '';

    // URL absolue → on garde
    if (this.isAbsoluteUrl(s)) return s;

    // Clé S3 → forcer public/
    const key = this.ensurePublicPrefix(s);

    // 1) urlResolver si dispo
    if (this.urlResolver) {
      try {
        const u = await this.urlResolver(key);
        if (u) return String(u);
      } catch (e) {
        console.warn('[IntroOutro] urlResolver error → fallback Amplify', e);
      }
    }

    // 2) tente la vignette
    try {
      const small = this.toSmallPreExt(key);
      return await this.getSignedUrlPublic(small);
    } catch {
      /* no-op */
    }

    // 3) original
    try {
      return await this.getSignedUrlPublic(key);
    } catch {
      /* no-op */
    }

    // 4) autre variante vignette
    try {
      const small2 = this.toSmallAfterExtKey(key);
      return await this.getSignedUrlPublic(small2);
    } catch (e) {
      console.warn('[IntroOutro] All attempts failed for', { raw: s, e });
      return '';
    }
  }

  private async refreshBg(screen: 'intro' | 'outro'): Promise<void> {
    const raw =
      screen === 'intro'
        ? this.firstImageKey || this.firstImageUrl || ''
        : this.lastImageKey || this.lastImageUrl || '';

    const url = await this.smallSignedUrl(raw); // ← ICI on utilise smallSignedUrl

    if (screen === 'intro') {
      this.introBgUrl = url;
      this.introBgErrorOnce = false;
    } else {
      this.outroBgUrl = url;
      this.outroBgErrorOnce = false;
    }
  }

  private async onBgError(): Promise<void> {
    const screen = this.activeScreen;
    const raw =
      screen === 'intro'
        ? this.firstImageKey || this.firstImageUrl || ''
        : this.lastImageKey || this.lastImageUrl || '';

    // Convertit URL → clé S3, sinon force public/ pour une clé
    const key = this.isAbsoluteUrl(raw) ? this.keyFromAbsoluteUrl(raw) : this.ensurePublicPrefixKey(raw);
    if (!key) return;

    const originalUrl = await this.signPublicKey(key); // ← signe l’original (pas la miniature)

    if (screen === 'intro') this.introBgUrl = originalUrl;
    else this.outroBgUrl = originalUrl;
  }

  private ensurePublicPrefix(k: string | null | undefined): string {
    const s = String(k || '').replace(/^\/+/, '');
    return s.startsWith('public/') ? s : `public/${s}`;
  }

  private async uploadRasterToS3(base64Data: string, screen: 'intro' | 'outro') {
    try {
      const ownerId = this.ownerId;
      const projectId = this.projectId;
      const camId = this.cameraId;

      if (!ownerId || !projectId || !camId) {
        console.error('❌ Impossible de récupérer ownerId, projectId ou cameraId (props manquantes)');
        return null;
      }

      const base64 = base64Data.replace(/^data:image\/\w+;base64,/, '');
      const buffer = Buffer.from(base64, 'base64');

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const fileName = `${screen}.png`;
      const key = `public/${ownerId}/${projectId}/${camId}/${fileName}`;

      await s3
        .putObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
          Body: buffer,
          ContentType: 'image/png',
          ACL: 'public-read',
        })
        .promise();

      const publicUrl = `https://erige-main-store-prod.s3.${region}.amazonaws.com/${key}`;
      this.$emit('export', {
        [`${screen}Png`]: publicUrl,
        [`${screen}Key`]: key,
        [`${screen}DurationMs`]: this.screenDurationMs(screen),
      });

      this.$bvToast?.toast(`✅ ${screen.toUpperCase()} enregistré avec succès !`, {
        title: 'Export réussi',
        variant: 'success',
        solid: true,
      });
      return publicUrl;
    } catch (error) {
      console.error(`❌ Erreur upload ${screen}:`, error);
      this.$bvToast?.toast(`❌ Erreur lors de l’envoi de ${screen}.png`, {
        title: 'Erreur',
        variant: 'danger',
        solid: true,
      });
      return null;
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('mousedown', this.onGlobalMouseDown);
    document.removeEventListener('keydown', this.onKeyDown);
    const stage = this.$refs.stage as HTMLElement;
    stage?.removeEventListener('dragstart', this.preventDrag);
  }

  @Watch('value', { deep: true })
  onModelChange(v: IntroOutroModel | undefined) {
    if (v) {
      this.local = JSON.parse(JSON.stringify(v));
      // ★ renormalise
      this.local.intro = this.normalizeScreenDefaults(this.local.intro);
      this.local.outro = this.normalizeScreenDefaults(this.local.outro);
      this.introMsLive = this.introDurationFromModel;
      this.outroMsLive = this.outroDurationFromModel;
    }
  }

  // === HANDLERS ===

  onResize() {
    const el = this.$refs.stage as HTMLElement;
    this.stageRect = el.getBoundingClientRect();
  }

  onBgLoaded() {
    this.onResize();
  }

  startDrag(kind: 'text' | 'logo', id: string, ev: MouseEvent) {
    this.selected = { type: kind, id };
    this.dragging = true;
    const el = this.$refs.stage as HTMLElement;
    this.stageRect = el.getBoundingClientRect();
    const scale = this.stageRect.width / this.width;

    const sel = this.selectedEl;
    const ox = ev.clientX - sel.x * scale;
    const oy = ev.clientY - sel.y * scale;
    this.dragOffset = { dx: ox, dy: oy };
  }

  collectGuides(excludeId: string | null) {
    const v: number[] = []; // vertical lines (x)
    const h: number[] = []; // horizontal lines (y)

    // canvas edges & centers
    v.push(0, this.width / 2, this.width);
    h.push(0, this.height / 2, this.height);

    // autres logos
    for (const l of this.current.logos) {
      if (excludeId && l.id === excludeId) continue;
      const b = this.getLogoBox(l);
      v.push(l.x, l.x + b.w, l.x + b.w / 2);
      h.push(l.y, l.y + b.h, l.y + b.h / 2);
    }

    // autres textes
    for (const t of this.current.texts) {
      if (excludeId && t.id === excludeId) continue;
      const w = t.w;
      const hpx = this.getTextDomHeightPx(t); // stage px
      const hCanvas = hpx / this.stageScale;
      v.push(t.x, t.x + w, t.x + w / 2);
      h.push(t.y, t.y + hCanvas, t.y + hCanvas / 2);
    }
    return { v, h };
  }

  onStageMouseDown(ev: MouseEvent) {
    const target = ev.target as HTMLElement;

    // si on édite et qu'on clique dans le stage : on ferme si clic hors du bloc
    if (this.isEditing && this.editingId) {
      const textEl = this.getTextRootEl(this.editingId);
      if (textEl && !textEl.contains(target)) {
        this.finishInlineEdit(true);
        this.selected = null;
      }
      return; // ne pas initier de drag
    }

    // clic vide -> déselection
    const item = target.closest ? target.closest('.ioe-item') : null;
    if (!item) this.selected = null;
  }

  onStageMouseMove(ev: MouseEvent) {
    if (this.isEditing) return;
    if (!this.stageRect) return;

    const scaleDOM = this.stageRect.width / this.width;

    // --- RESIZE (logo OU texte)
    if (this.resizing) {
      const r = this.resizing;

      const dx = (ev.clientX - r.startMouseX) / scaleDOM;

      const sx = r.corner.indexOf('e') >= 0 ? 1 : -1; // sens horizontal
      const sy = r.corner.indexOf('s') >= 0 ? 1 : -1; // sens vertical

      if (this.selected && this.selected.type === 'logo') {
        // === LOGO: conserve le ratio, resize par la largeur ===
        const logo = this.current.logos.find((l) => l.id === r.id);
        if (!logo || !r.natW || !r.natH) return;

        let newW = Math.max(24, r.startW + sx * dx);
        const ratio = r.natH / r.natW;
        let newH = Math.max(24, newW * ratio);

        // repositionne si on tire côté Ouest/Nord
        let nx = r.startX;
        let ny = r.startY;
        if (sx < 0) nx = r.startX + (r.startW - newW);
        if (sy < 0) ny = r.startY + (r.startH - newH);

        // snap position (taille non "snapée")
        const snapped = this.applySnapXY(nx, ny, newW, newH, r.id);
        logo.x = snapped.x;
        logo.y = snapped.y;
        logo.scale = newW / r.natW;

        this.emitModel();
        return;
      } else if (this.selected && this.selected.type === 'text') {
        // === TEXTE: resize largeur (t.w), la hauteur suit le wrap ===
        const t = this.current.texts.find((tt) => tt.id === r.id);
        if (!t) return;

        const dy = (ev.clientY - r.startMouseY) / scaleDOM;

        // Largeur (comme avant)
        let newW = Math.max(120, r.startW + sx * ((ev.clientX - r.startMouseX) / scaleDOM));

        // Hauteur minimale (≈ une ligne)
        const minH = Math.ceil((t.fontSize || 12) * 1.15);

        // ⬅️ NOUVEAU : calcul de la nouvelle hauteur
        let newH = Math.max(minH, r.startH + sy * dy);

        // Reposition si on tire côté Ouest/Nord pour garder le coin opposé fixe
        let nx = r.startX;
        let ny = r.startY;
        if (sx < 0) nx = r.startX + (r.startW - newW);
        if (sy < 0) ny = r.startY + (r.startH - newH);

        // Snap avec la nouvelle boîte (w,h)
        const snapped = this.applySnapXY(nx, ny, newW, newH, r.id);
        t.x = snapped.x;
        t.y = snapped.y;
        t.w = Math.round(newW);
        t.h = Math.round(newH); // ⬅️ on persiste la hauteur

        this.emitModel();
        return;
      }

      return;
    }

    // --- DRAG (logo OU texte)
    if (!this.dragging || !this.selectedEl) return;

    const nx = (ev.clientX - this.dragOffset.dx) / scaleDOM;
    const ny = (ev.clientY - this.dragOffset.dy) / scaleDOM;

    let w = 150;
    let h = 50;

    if (this.selected && this.selected.type === 'logo') {
      const box = this.getLogoBox(this.selectedEl);
      w = box.w;
      h = box.h;
    } else if (this.selected && this.selected.type === 'text') {
      const t = this.selectedEl as any; // TextBlock
      w = Math.max(120, t.w);
      h = this.getTextDomHeightPx(t) / scaleDOM;
    }

    const exclId = this.selected ? this.selected.id : null;
    const snap = this.applySnapXY(nx, ny, w, h, exclId);

    this.selectedEl.x = snap.x;
    this.selectedEl.y = snap.y;

    this.emitModel();
  }

  onStageMouseUp() {
    if (this.isEditing) return;
    this.dragging = false;
    this.resizing = null;
    // cacher les guides
    this.guidesV = [];
    this.guidesH = [];
  }

  startInlineEdit(t: TextBlock) {
    this.selected = { type: 'text', id: t.id };
    this.editingId = t.id;
    this.editingBackup = t.text || '';
    this.dragging = false;

    this.$nextTick(() => {
      const ta = this.getEditAreaEl(t.id);
      if (ta) {
        this.autoResizeTextarea(ta);
        ta.selectionStart = ta.selectionEnd = ta.value.length;
        ta.focus();
      }
    });
  }

  finishInlineEdit(apply: boolean) {
    if (!apply && this.editingId) {
      const t = this.current.texts.find((x) => x.id === this.editingId);
      if (t) t.text = this.editingBackup;
    }
    this.editingId = null;
    this.editingBackup = '';
    this.emitModel();
  }

  onEditKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.finishInlineEdit(false);
    } else if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
      this.finishInlineEdit(true);
    } else if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'b' && this.selectedType === 'text') {
      e.preventDefault();
      this.toggleBold(this.selectedEl as TextBlock);
    } else if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'i' && this.selectedType === 'text') {
      e.preventDefault();
      this.toggleItalic(this.selectedEl as TextBlock);
    } else if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'u' && this.selectedType === 'text') {
      e.preventDefault();
      this.toggleUnderline(this.selectedEl as TextBlock);
    }
  }

  onEditInput(t: TextBlock) {
    const ta = this.getEditAreaEl(t.id);
    if (ta) this.autoResizeTextarea(ta);
    this.emitModel();
  }

  autoResizeTextarea(ta: HTMLTextAreaElement) {
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  }

  // Style du textarea en DOM (échelle stage)
  textEditStyle(t: TextBlock) {
    const scale = this.stageRect ? this.stageRect.width / this.width : 1;
    const st: any = {
      fontFamily: `${t.fontFamily}, sans-serif`,
      fontSize: t.fontSize * scale + 'px',
      lineHeight: String(1.15),
      color: t.color,
      textAlign: t.align as any,
      width: '100%',
      fontWeight: t.bold ? '700' : '400',
      fontStyle: t.italic ? 'italic' : 'normal',
      textDecoration: t.underline ? 'underline' : 'none',
    };
    if (t.h) st.minHeight = t.h * scale + 'px';
    return st;
  }

  incFont(t: TextBlock) {
    t.fontSize = Math.min(300, (t.fontSize || 12) + 2);
    this.emitModel();
  }
  decFont(t: TextBlock) {
    t.fontSize = Math.max(8, (t.fontSize || 12) - 2);
    this.emitModel();
  }
  toggleBold(t: TextBlock) {
    t.bold = !t.bold;
    this.emitModel();
  }
  toggleItalic(t: TextBlock) {
    t.italic = !t.italic;
    this.emitModel();
  }
  toggleUnderline(t: TextBlock) {
    t.underline = !t.underline;
    this.emitModel();
  }
  setColor(t: TextBlock, c: string) {
    t.color = c || '#FFFFFF';
    this.emitModel();
  }
  setFont(t: TextBlock, f: string) {
    t.fontFamily = f || 'Helvetica';
    this.emitModel();
  }
  setAlign(t: TextBlock, a: Align) {
    t.align = a;
    this.emitModel();
  }

  onLogoUpload(e: Event) {
    const input = e.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    const fr = new FileReader();
    fr.onload = () => {
      const src = String(fr.result);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        this.current.logos.push({
          id: this.uid(),
          src,
          x: Math.round(this.width * 0.7),
          y: Math.round(this.height * 0.7),
          scale: Math.min(1, 300 / img.width || 1),
          natW: img.width,
          natH: img.height,
        });
        this.emitModel();
      };
      img.src = src;
    };
    fr.readAsDataURL(file);
    (e.target as HTMLInputElement).value = '';
  }

  addText() {
    this.current.texts.push({
      id: this.uid(),
      text: 'Votre texte ici',
      x: Math.round(this.width * 0.1),
      y: Math.round(this.height * 0.2),
      fontSize: 120,
      fontFamily: 'Montserrat',
      color: '#FFFFFF',
      align: 'left',
      w: Math.round(this.width * 0.6),
      bold: false,
      italic: false,
      underline: false,
    });
    this.emitModel();
  }

  removeSelected() {
    if (!this.selected) return;
    if (this.selected.type === 'text') {
      this.current.texts = this.current.texts.filter((t) => t.id !== this.selected!.id);
    } else {
      this.current.logos = this.current.logos.filter((l) => l.id !== this.selected!.id);
    }
    this.selected = null;
    this.emitModel();
  }

  onLogoScale() {
    if (this.selected?.type !== 'logo') return;
    const el = this.selectedEl as LogoItem;
    el.scale = this.logoScalePct / 100;
    this.emitModel();
  }

  applySnapXY(x: number, y: number, w: number, h: number, excludeId: string | null) {
    const T = this.snap.threshold,
      S = this.snap.step;
    const guides = this.collectGuides(excludeId);

    let nx = x,
      ny = y;
    let vHit: number[] = [],
      hHit: number[] = [];

    // X : left / right / center
    for (const gx of guides.v) {
      if (Math.abs(nx - gx) <= T) {
        nx = gx;
        vHit = [gx];
        break;
      }
      if (Math.abs(nx + w - gx) <= T) {
        nx = gx - w;
        vHit = [gx];
        break;
      }
      if (Math.abs(nx + w / 2 - gx) <= T) {
        nx = gx - w / 2;
        vHit = [gx];
        break;
      }
    }
    // Y : top / bottom / center
    for (const gy of guides.h) {
      if (Math.abs(ny - gy) <= T) {
        ny = gy;
        hHit = [gy];
        break;
      }
      if (Math.abs(ny + h - gy) <= T) {
        ny = gy - h;
        hHit = [gy];
        break;
      }
      if (Math.abs(ny + h / 2 - gy) <= T) {
        ny = gy - h / 2;
        hHit = [gy];
        break;
      }
    }

    // Snap grille (moins prioritaire)
    if (S > 0) {
      const gx = Math.round(nx / S) * S;
      const gy = Math.round(ny / S) * S;
      if (Math.abs(nx - gx) <= T) nx = gx;
      if (Math.abs(ny - gy) <= T) ny = gy;
    }

    // clamp
    nx = Math.max(0, Math.min(this.width - w, nx));
    ny = Math.max(0, Math.min(this.height - h, ny));

    this.guidesV = vHit;
    this.guidesH = hHit;

    return { x: Math.round(nx), y: Math.round(ny) };
  }

  emitModel() {
    this.$emit('input', JSON.parse(JSON.stringify(this.local)));
  }

  onKeyDown = (e: KeyboardEvent) => {
    if (this.isEditing) return;
    if ((e.key === 'Delete' || e.key === 'Backspace') && this.selected) {
      e.preventDefault();
      this.removeSelected();
    }
  };

  // === RENDER STYLES ===

  logoStyle(l: LogoItem) {
    if (!this.stageRect) return {};
    const scale = this.stageRect.width / this.width;
    const w = (l.natW || 200) * (l.scale || 1) * scale;
    const h = (l.natH || 100) * (l.scale || 1) * scale;
    return {
      left: l.x * scale + 'px',
      top: l.y * scale + 'px',
      width: w + 'px',
      height: h + 'px',
    };
  }

  textDomStyle(t: TextBlock) {
    if (!this.stageRect) return {};
    const scale = this.stageRect.width / this.width;
    const style: any = {
      left: t.x * scale + 'px',
      top: t.y * scale + 'px',
      width: t.w * scale + 'px',
    };
    if (t.h) style.minHeight = t.h * scale + 'px';
    return style;
  }

  wrapAndDrawText(
    ctx: CanvasRenderingContext2D,
    text: string,
    xLeft: number,
    yTop: number,
    maxW: number,
    lineH: number,
    align: Align
  ) {
    // On convertit align en position d’ancrage
    let drawX = xLeft;
    if (align === 'center') drawX = xLeft + maxW / 2;
    else if (align === 'right') drawX = xLeft + maxW;

    ctx.textAlign = align as DOMCanvasTextAlign;
    const words = (text || '').split(/\s+/);
    let line = '',
      y = yTop;

    for (let i = 0; i < words.length; i++) {
      const test = line ? line + ' ' + words[i] : words[i];
      const m = ctx.measureText(test);
      if (m.width > maxW && line) {
        ctx.fillText(line, drawX, y);
        line = words[i];
        y += lineH;
      } else {
        line = test;
      }
    }
    if (line) ctx.fillText(line, drawX, y);
    return y + lineH - yTop; // hauteur utilisée
  }

  textCss(t: TextBlock) {
    return {
      color: t.color,
      'font-family': t.fontFamily + ', sans-serif',
      'font-size': t.fontSize * (this.stageRect ? this.stageRect.width / this.width : 1) + 'px',
      'text-align': t.align,
      'line-height': 1.15,
      'white-space': 'pre-wrap',
      'text-shadow': '0 2px 6px rgba(0,0,0,0.3)',
      'font-weight': t.bold ? '700' : '400',
      'font-style': t.italic ? 'italic' : 'normal',
      'text-decoration': t.underline ? 'underline' : 'none',
    };
  }

  // === EXPORT ===

  async exportOne() {
    const pngData = await this.rasterize(this.activeScreen);
    const publicUrl = await this.uploadRasterToS3(pngData, this.activeScreen);

    if (publicUrl) {
      this.$emit('export', {
        [this.activeScreen + 'Png']: publicUrl,
        [this.activeScreen + 'DurationMs']: this.screenDurationMs(this.activeScreen),
      });
    }
  }

  async exportBoth() {
    const [introData, outroData] = await Promise.all([this.rasterize('intro'), this.rasterize('outro')]);

    const [introUrl, outroUrl] = await Promise.all([
      this.uploadRasterToS3(introData, 'intro'),
      this.uploadRasterToS3(outroData, 'outro'),
    ]);

    if (introUrl && outroUrl) {
      this.$bvToast?.toast('✅ Intro & Outro exportées avec succès !', {
        title: 'Succès',
        variant: 'success',
        solid: true,
      });

      this.$emit('export', {
        introPng: introUrl,
        introDurationMs: this.introDurationFromModel,
        outroPng: outroUrl,
        outroDurationMs: this.outroDurationFromModel,
      });
    }
  }

  async rasterize(screen: ScreenType): Promise<string> {
    const cfg = this.local[screen];

    // Canvas cible
    const canvas = document.createElement('canvas');
    canvas.width = this.width;
    canvas.height = this.height;
    const ctx = canvas.getContext('2d')!;

    // === FOND ===
    if (cfg.bgMode === 'color') {
      // Fond uni
      ctx.fillStyle = cfg.bgColor || '#0b1a2a';
      ctx.fillRect(0, 0, this.width, this.height);
    } else {
      // Fond image floutée
      const raw =
        screen === 'intro'
          ? this.firstImageKey || this.firstImageUrl || ''
          : this.lastImageKey || this.lastImageUrl || '';

      const bgUrl = await this.smallSignedUrl(raw);

      try {
        const bg = await this.loadImage(bgUrl);
        ctx.filter = `blur(${cfg.blur}px)`;
        this.drawCover(ctx, bg, this.width, this.height);
        ctx.filter = 'none';
      } catch (e) {
        // Fallback si l'image ne charge pas
        ctx.fillStyle = '#0b1a2a';
        ctx.fillRect(0, 0, this.width, this.height);
      }
    }

    // Pré-chargement des logos (tolérant aux erreurs)
    const logos = await Promise.all(
      cfg.logos.map(async (l) => {
        try {
          const img = await this.loadImage(l.src);
          return { l, img };
        } catch {
          return { l, img: null as HTMLImageElement | null };
        }
      })
    );

    // Helper: wrap paragraphe
    function drawWrapped(
      ctx2: CanvasRenderingContext2D,
      text: string,
      xLeft: number,
      yTop: number,
      maxW: number,
      lineH: number,
      align: 'left' | 'center' | 'right'
    ) {
      // ancrage X selon align
      let anchorX = xLeft;
      if (align === 'center') anchorX = xLeft + maxW / 2;
      else if (align === 'right') anchorX = xLeft + maxW;

      ctx2.textAlign = align as DOMCanvasTextAlign;

      const words = (text || '').split(/\s+/);
      let line = '';
      let y = yTop;

      for (let i = 0; i < words.length; i++) {
        const test = line ? line + ' ' + words[i] : words[i];
        const width = ctx2.measureText(test).width;
        if (width > maxW && line) {
          ctx2.fillText(line, anchorX, y);
          line = words[i];
          y += lineH;
        } else {
          line = test;
        }
      }
      if (line) ctx2.fillText(line, anchorX, y);

      return y + lineH - yTop; // hauteur utilisée
    }

    // === TEXTES ===
    for (const t of cfg.texts) {
      ctx.save();
      const align = t.align === 'center' ? 'center' : t.align === 'right' ? 'right' : 'left';
      ctx.textBaseline = 'top';
      ctx.fillStyle = t.color || '#fff';
      ctx.font = `${Math.max(8, t.fontSize)}px ${t.fontFamily || 'Helvetica'}, sans-serif`;

      const lineH = t.fontSize * 1.15;
      const maxW = Math.max(60, t.w || Math.round(this.width * 0.6));

      // support des sauts de ligne explicites
      const paragraphs = (t.text || '').split('\n');
      let y = t.y;
      for (const p of paragraphs) {
        const used = drawWrapped(ctx, p, t.x, y, maxW, lineH, align as any);
        y += used;
      }
      ctx.restore();
    }

    // === LOGOS ===
    for (const { l, img } of logos) {
      if (!img) continue; // skip si logo non chargé
      const dw = (l.natW || img.width) * (l.scale || 1);
      const dh = (l.natH || img.height) * (l.scale || 1);
      ctx.drawImage(img, l.x, l.y, dw, dh);
    }

    return canvas.toDataURL('image/png');
  }

  // helpers
  uid(): string {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  drawCover(ctx: CanvasRenderingContext2D, img: HTMLImageElement, W: number, H: number) {
    const rImg = img.width / img.height;
    const rCan = W / H;
    let w = W,
      h = H,
      x = 0,
      y = 0;
    if (rImg > rCan) {
      // image plus large -> on coupe les côtés
      h = H;
      w = H * rImg;
      x = (W - w) / 2;
      y = 0;
    } else {
      w = W;
      h = W / rImg;
      x = 0;
      y = (H - h) / 2;
    }
    ctx.drawImage(img, x, y, w, h);
  }

  startResize(corner: 'nw' | 'ne' | 'sw' | 'se', id: string, ev: MouseEvent) {
    if (!this.stageRect) return;
    // identité de l’élément sélectionné
    const kind =
      this.selected && this.selected.id === id
        ? this.selected.type
        : this.current.logos.some((l) => l.id === id)
        ? 'logo'
        : 'text';
    if (!kind) return;

    if (kind === 'logo') {
      const logo = this.current.logos.find((l) => l.id === id);
      if (!logo) return;
      const box = this.getLogoBox(logo);
      this.resizing = {
        id,
        corner,
        startMouseX: ev.clientX,
        startMouseY: ev.clientY,
        startX: logo.x,
        startY: logo.y,
        startW: box.w,
        startH: box.h,
        startScale: logo.scale || 1,
        natW: logo.natW || 200,
        natH: logo.natH || 100,
      };
      this.selected = { type: 'logo', id };
    } else {
      const t = this.current.texts.find((tt) => tt.id === id);
      if (!t) return;
      const hCanvas = this.getTextDomHeightPx(t) / this.stageScale;
      this.resizing = {
        id,
        corner,
        startMouseX: ev.clientX,
        startMouseY: ev.clientY,
        startX: t.x,
        startY: t.y,
        startW: t.w,
        startH: hCanvas,
      };
      this.selected = { type: 'text', id };
    }
  }

  @Watch('firstImageUrl') onFirstUrlChanged() {
    void this.refreshBg('intro');
  }
  @Watch('firstImageKey') onFirstKeyChanged() {
    void this.refreshBg('intro');
  }
  @Watch('lastImageUrl') onLastUrlChanged() {
    void this.refreshBg('outro');
  }
  @Watch('lastImageKey') onLastKeyChanged() {
    void this.refreshBg('outro');
  }
}
